import { STORAGE_KEY as CHANGELOG_SEEN_KEY } from "../data/changelog";

/**
 * Claves que NO son de sesión: describen al dispositivo/navegador, no al
 * usuario que tiene la sesión abierta. Sobreviven al login, al logout y al
 * cierre forzado por token vencido.
 *
 * `changelog_seen_version` es la más importante: si se borra, el modal de
 * Novedades se vuelve a abrir aunque el usuario ya lo haya visto y aunque el
 * changelog no haya cambiado. Eso pasaba en cada deploy — el refresh del token
 * fallaba, se forzaba el cierre de sesión, se limpiaba TODO el localStorage y
 * la marca se perdía. El usuario terminaba viendo el aviso de novedades una y
 * otra vez por releases que solo traían correcciones internas.
 *
 * `theme` no está en la lista a propósito: se define por rol al iniciar sesión
 * (ver useAuth), así que arrastrarlo entre usuarios sería incorrecto.
 */
const CLAVES_DISPOSITIVO = [CHANGELOG_SEEN_KEY, "lang"];

/**
 * Limpia el almacenamiento de la sesión conservando las preferencias del
 * dispositivo.
 *
 * Se usa en los tres puntos donde termina una sesión —login de otro usuario,
 * logout explícito y cierre forzado por token vencido— para que se comporten
 * igual. Antes cada uno hacía su propio `localStorage.clear()` y solo dos de
 * los tres se acordaban de preservar la marca del changelog.
 */
export function limpiarSesion() {
  let preservadas = [];
  try {
    preservadas = CLAVES_DISPOSITIVO
      .map((clave) => [clave, localStorage.getItem(clave)])
      .filter(([, valor]) => valor != null);
  } catch {
    /* localStorage bloqueado (modo privado): no hay nada que preservar */
  }

  try {
    localStorage.clear();
    for (const [clave, valor] of preservadas) localStorage.setItem(clave, valor);
  } catch {
    /* noop */
  }
}
